import React, { useContext, useEffect, useState } from "react";

import moment from "moment";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faTriangleExclamation,
    faFilePdf,
    faXmark,
    faThumbsUp,
    faThumbsDown,
    faDownload,
    faSmile
} from "@fortawesome/free-solid-svg-icons";

import './ChecklistRegInfo.css';
import axios from "axios";
import clienteAxios from "../../config/axios";
import activoContext from "../../context/activoContex/activoContex";

const ChecklistRegInfo = ({checkInfo, files, cerrar}) =>{

    const acContext = useContext(activoContext);
    const {activoList} = acContext;
    const [loading, setLoading] = useState(true);
    const [info,setInfo] = useState(null);

    let setLecturas = async() =>{
        let activoFiltrado = activoList.filter(a => a._id == checkInfo.activoID)[0];
        console.log("checkInfo");
        console.log(checkInfo);
        
        const res = await clienteAxios.get(`/checklistReg/getLecturas?activoID=${checkInfo.activoID}&fecReg=${checkInfo.fecFin}&uniMed=${activoFiltrado.DEFAULTUNIMED.value}`);
        if(res.data != undefined){
            const newInfo = {
                ...checkInfo,                
                previousLect : (res.data.data.preLastLectura != undefined) ? res.data.data.preLastLectura : 0,
                
                lastLect : checkInfo.endedDirectly ? undefined : (res.data.data.lastLectura != undefined) ? res.data.data.lastLectura : {valor: 0},
                tiempoCronometro: (checkInfo.tiempoCronometro != undefined) ? checkInfo.tiempoCronometro : 0
            }
            setInfo(newInfo);
            setLoading(false);
        }
    }

    const generaPDF = (checkInfo, usuario) =>{

    }

    useEffect(()=>{
        if(activoList != undefined && Array.isArray(activoList)) setLecturas();
    },[activoList]);

    if(info != null && !loading) return <div className='container-gr-req'>
    <div className='container-r-list-item-header-info'>
        <div className='label-req'>{info.codigo + ' - ' + info.checkNro}</div>
        <div className='r-list-item-header-title'>{info.name}</div>
        <button className="minimizarBtn" onClick={() => cerrar(null)}>X</button>
    </div>
    <div className='container-r-item-details'>
        <div className='container-r-info-p'>
            <div className='label-req-title'>Codigo Activo </div><div className='r-list-item-details-clave-v'>{info.codActivo}</div>
            <div className='label-req-title'>Emitido por </div><div className='r-list-item-details-title-v'>{info.userName}</div>
        </div>
        <div className='container-r-item-title-details'>Fecha</div>
        <div className='container-r-fecha'>
            <div className='label-req-fecha'>
                <div className='r-list-item-details-data-v'>Alta </div><div className='r-list-item-details-fecha-v'>{moment(info.fecAlt).format('DD-MM-YYYY')}</div>
            </div>
        </div>
        <div className='container-r-item-title-details'>Tiempo cronometrado</div>
        <div className='container-r-fecha'>
            <div className='label-req-fecha'>
                <div className='r-list-item-details-data-v'>Duración </div><div className='r-list-item-details-fecha-v'>{moment.utc(info.tiempoCronometro * 1000).format('HH:mm:ss')}</div>
            </div>
        </div>

        {info.cantidadCombustible && <div className='container-r-item-title-details'>Combustible Registrado</div>}
        {info.cantidadCombustible && <div className='container-r-fecha'>
            <div className='label-req-fecha'>
                <div className='r-list-item-details-data-v'>Cantidad </div><div className='r-list-item-details-fecha-v'>{info.cantidadCombustible}</div>
            </div>
        </div>}

        {info.duracionEspecificada && <div className='container-r-item-title-details'>Duración de Carga</div>}
        {info.duracionEspecificada && <div className='container-r-fecha'>
            <div className='label-req-fecha'>
                <div className='r-list-item-details-data-v'>Duración </div><div className='r-list-item-details-fecha-v'>{String(Math.floor(Number(info.duracionEspecificada) / 60)).padStart(2,'0')}:{String(Number(info.duracionEspecificada) % 60).padStart(2,'0')}</div>
            </div>
        </div>}

        {info.sector && <div className='container-r-item-title-details'>Sector</div>}
        {info.sector && <div className='container-r-fecha'>
            <div className='label-req-fecha'>
                <div className='r-list-item-details-data-v'>Sector </div><div className='r-list-item-details-fecha-v'>{info.sector}</div>
            </div>
        </div>}

        {info.imputacionesRRHH && info.imputacionesRRHH.length > 0 && <>
            <div className="container-r-item-title-details">Imputaciones RRHH: {info.imputacionesRRHH.length}</div>
            <div className="container-list-products-r-gral">
                {info.imputacionesRRHH.map((impu, idx) => (
                    <div className="container-list-products-r" key={idx}>
                        <div className="container-list-product-r-icon">
                            <div className='list-item-icon-r'><FontAwesomeIcon icon={faSmile} /></div>
                            <div className="list-item-title-r">{impu.legajo?.value}</div>
                        </div>
                        <div className="container-list-products-r-details">
                            <div>{impu.legajo?.label}</div>
                            {impu.textAdic && <div>{impu.textAdic}</div>}
                            {/* <div className="container-cantidad-product-r">Cantidad Horas: {impu.cantHoras}</div> */}
                        </div>
                    </div>
                ))}
            </div>
        </>}

        <div className='container-r-item-title-details'>{checkInfo.endedDirectly ? 'Lectura al finalizarlo directamente:' : 'Lecturas'}</div>
        <div className='container-r-fecha'>
            <div className='divLabelLect'>
                <div className='labelLect'>Lectura {info.lastLect ? 'previa' : ''}: </div>
                <div className='labelValueLect'>{info.previousLect.valor}</div>
            </div>
            {
                info.lastLect && <div className='divLabelLect'>
                    <div className='labelLect'>Lectura posterior: </div>
                    <div className='labelValueLect'>{info.lastLect.valor}</div>
                </div>
            }
        </div>
        
        <div className='container-r-item-title-details'>Orden de Trabajo Asociada</div>
        <div className='container-r-fecha'>
            <div className='divLabelLect'>
                <div className='labelLect'>{info.nroOdtAsociada ? `${info.codOdtAsociada} - ${info.nroOdtAsociada}` : 'No tiene orden de trabajo asociada'}</div>
            </div>
        </div>

        <div className='container-r-item-title-details'>Controles: {(info.controles != undefined) ? info.controles.length : 'No hay controles asociadas'}</div>
        <div className="container-list-products-r-gral">
            {(info.controles != undefined) && info.controles.map((ctrl) => {
                return (
                    <div className="container-list-products-r" key={ctrl.codRed}>
                        <div className="container-list-product-r-icon">
                            <div className='list-item-icon-r'><FontAwesomeIcon style={{color:(ctrl.checked == 'negative') ? 'red' : 'green'}} icon={(ctrl.checked == 'positive') ? faThumbsUp : faThumbsDown} /></div>
                            <div className="list-item-title-r">
                                {ctrl.codigo}
                            </div>
                        </div>
                        <div className="container-list-products-r-details">
                            <div>
                                {ctrl.descrp}
                            </div>
                            <div className="container-cantidad-product-r">
                                {ctrl.textAdic}
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>

        <div className='container-r-item-title-details'>
            <div>Archivos</div>
            {files && files.length > 0 && (
                <div className="container-button-download">
                    <button className="button-download" onClick={() => files.forEach(f => window.open(f.url))}>
                        Descargar Todos <FontAwesomeIcon icon={faDownload} />
                    </button>
                </div>
            )}
        </div>
        <div className="container-files-rq">
            <ul className="container-files-rq-details">
                {files?.map((file) => (
                    <li className="container-files-rq-details-items" key={file.name} onClick={() => window.open(file.url)}>{file.name}</li>
                ))}
            </ul>
        </div>

    </div>
</div>
else return <div className='container-gr-req'>
    <div className='container-r-list-item-header-info'>
        <h3 className="warningStatusMsg">Cargando<span>.</span><span>.</span><span>.</span></h3>
    </div>
</div>
}

export default ChecklistRegInfo;